<template>
<div>
  <div class="content ht-100v pd-0">
    <div class="content-body pd-10">
      <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
              <li class="breadcrumb-item">
                <router-link to="/admin/">Admin</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Stats</li>
            </ol>
          </nav>
          <h4 class="mg-b-0 tx-spacing--1">Active Profiles</h4>
        </div>


      </div>
      <native-card :carditems="admin.batchcard"></native-card>
      <hr>
      <BatchTable />
    </div>
  </div>
</div>

</template>

<script>
import NativeCard from "@/components/card/NativeCard";
import { mapState } from 'vuex'
import BatchTable from "@/components/table/BatchTable";

export default {
  name: "Stats",
  components:{
    BatchTable,
    NativeCard
  },
  computed:{
    ...mapState(['ft', 'admin', 'auth'])
  }
}

</script>

<style scoped>

</style>
